// extracted by mini-css-extract-plugin
export default {"addButton":"NotesTable_addButton__ByKnC","PopoverContent":"NotesTable_PopoverContent__QWlaL","Table":"NotesTable_Table__FL0Z3"};